<template>
  <div class="text-center" v-click-outside="clearErr">
    <v-dialog v-model="showMessage" width="30%">
      <v-card :class="statusType ? '!bg-primary-900' : '!bg-red-500'" class="rounded-xl !text-white">
        <v-card-text class="text-center">
          {{ statusMessage }}
        </v-card-text>
        <v-card-actions>
          <v-btn block @click="clearErr">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["statusMessage", "showMessage", "statusType"]),
  },
  methods: {
    ...mapActions(["SetMessageDialog"]),
    clearErr() {
      this.SetMessageDialog({ show: false, message: "" });
    },
  },
};
</script>
